/* eslint-disable import/order */
import { createApp } from 'vue'

// eslint-disable-next-line no-unused-vars
import i18n from './i18n/i18n'
// @ts-ignore
import App from './App.vue'
// @ts-ignore
import { createRouter } from './router'
// @ts-ignore
import store from './store/store'
import { Vue3Mq } from 'vue3-mq'
import VueGtag from 'vue-gtag'
// @ts-ignore
import VueConfetti from 'vue-confetti'
// @ts-ignore
import FloatingVue from 'floating-vue'
// @ts-ignore
import VueClipboard from 'vue3-clipboard'
// @ts-ignore
import { createGtm } from '@gtm-support/vue-gtm'
import VueApexCharts from 'vue3-apexcharts'
import { createPopper } from '@popperjs/core'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

// plugins
// @ts-ignore
import VueCan from '@/plugins/vue-can.js'

import * as Sentry from '@sentry/vue'

import { eventEmitter } from './event-bus'

import VueImageZoomer from 'vue-image-zoomer'

const app = createApp(App)

// scripts
import '@/utilities/prototype.js'

// styles
import 'vue-multiselect/dist/vue-multiselect.css'
import 'nprogress/nprogress.css'
import 'vue-image-zoomer/dist/style.css'
import 'floating-vue/dist/style.css'
import 'bootstrap-float-label/dist/bootstrap-float-label.min.css'
import '@/assets/scss/app-custom.scss'
import '@/assets/scss/icons.scss'
import '@/assets/scss/app.scss'
import '@/assets/scss/style.scss'

// helpers
import utilities from '@/utilities/utilities'
import '@/utilities/echo.js'

// filters
import { filters } from '@/filters/index'

// directives
import clickOutside from '@/directives/click-outside.js'
import preventNumberScroll from '@/directives/prevent-number-scroll'
import StickyScrollDirective from '@/directives/sticky-on-scroll.js'
import autoHideDirective from '@/directives/auto-hide-directive'
import firebase from './plugins/firebase'
// @ts-ignore
app.config.globalProperties.$createPopper = createPopper
app.directive('click-outside', clickOutside)
app.directive('prevent-number-scroll', preventNumberScroll)
app.directive('auto-hide', autoHideDirective)
app.directive('sticky-on-scroll', StickyScrollDirective)
// @ts-ignore
Object.entries(utilities).forEach(item => {
  app.config.globalProperties['$' + `${item[0]}`] = item[1]
})
// @ts-ignore
app.config.globalProperties.$filters = filters

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    emitter: typeof eventEmitter
  }

  interface ComponentCustomProperties {
    VueCan: {
      $can: (permission: string, checkAdmin?: boolean) => boolean
    }
  }
}

app.config.globalProperties.eventEmitter = eventEmitter
//app.config.globalProperties.confetti = VueConfetti

const router = createRouter(app)
if (import.meta.env.MODE === 'production') {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        mask: ['.form-control', '.multiselect'],
        maskAllText: false,
        blockAllMedia: false,

        networkDetailAllowUrls: [/\/v1\/(retailer).*/],

        beforeErrorSampling: function (event) {
          if (!window.location.pathname.startsWith('/retailer/application/')) {
            return false
          }

          return true
        }
      })
    ],

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', 'tarfin.com', /^\//]
  })

  Sentry.setTag('locale', import.meta.env.VITE_I18N_LOCALE)
  Sentry.setTag('env', import.meta.env.MODE)
  Sentry.setTag('country', import.meta.env.VITE_COUNTRY)
}

app
.use(router)
.use(store as any)
.use(Vue3Mq, {
  preset: 'bootstrap4',
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1280
  }
})
.use(VueGtag as any, {
  config: { id: 'UA-70760483-1' } // Bu Id'yi Product ekibinin haberi olmadan değiştirme
})
.use(
  (createGtm as any)({
    id: 'GTM-TBC5RGQ' // Bu Id'yi Product ekibinin haberi olmadan değiştirme
  })
)
// @ts-ignore
.use(VueApexCharts)
.use(VueImageZoomer)
.use(VueCan as any, { store })
.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true
})
.use(VueConfetti)
.use(FloatingVue)
.use(i18n)
.use(firebase)
.mount('#app')
